// src/api/axiosInstance.js
import axios from 'axios';
// import { getAuthToken } from './tokenService';
// import { getAuthToken } from './tokenService';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
});

// Add a request interceptor to attach the Bearer token from the tokenService
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    // console.log(`storage found ${token}`);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authToken');
      // Redirect user to the login page if authentication has expired.
      // You can replace '/login' with your default page.
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
